<script>
	import ContactSection from "./components/ContactSection.svelte";
	import ContentSection from "./components/ContentSection.svelte";
	import InteractableText from "./components/InteractableText.svelte";
	import Padding from "./components/Padding.svelte";
	import TextureBackground from "./components/TextureBackground.svelte";
	import * as content from "./content.json";
	import { panelClose, panelOpen } from "./stores/panelStore";

	let blurVisible = false;

	const closePanel = () => {
		panelClose.update((n) => n + 1);
	};

	panelClose.subscribe((val) => {
		if (val) blurVisible = false;
	});

	panelOpen.subscribe((val) => {
		if (val) blurVisible = true;
	});
</script>

<TextureBackground />
<div
	class="screen-fade main-background-color"
	class:blur-visible={blurVisible}
	on:click|stopPropagation={closePanel}
/>
<main>
	<Padding vertical="160" />
	<div class="personal-info">
		<InteractableText text="OSAMA" />
		<ContactSection variant="tiny" />
		<h2>Software Engineer</h2>
	</div>
	<div class="body-text about-text">
		I have more than 5 years of professional experience, as well as a lot of personal projects that you can see listed below.
	</div>
	<Padding vertical="160" />

	{#each content.overview as overview, i}
		<Padding vertical="28" />
		<ContentSection content={overview} />
		<Padding vertical="28" />
	{/each}

	<Padding vertical="160" />
	<ContactSection />
	<Padding vertical="160" />
</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
	}

	.personal-info {
		display: inline-block;
		position: relative;
	}

	.about-text {
		position: relative;
		max-width: 80%;
		margin-left: auto;
		margin-right: auto;
	}

	@media only screen and (min-width: 768px) {
		.about-text {
			max-width: 40%;
		}
	}

	.screen-fade {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 200vw;
		height: 200vh;

		z-index: 0;

		opacity: 0;
		pointer-events: none;
		transition: opacity 0.3s linear;
	}

	.blur-visible.screen-fade {
		opacity: 0.85;
		pointer-events: all;
		z-index: 10;
	}
</style>
